/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_LostInputs */

const en_welcome_phase_lost = /** @type {(inputs: Welcome_Phase_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session terminated`)
};

const fr_welcome_phase_lost = /** @type {(inputs: Welcome_Phase_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session terminée`)
};

const ms_sg2_welcome_phase_lost = /** @type {(inputs: Welcome_Phase_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi tamat`)
};

/**
* | output |
* | --- |
* | "Session terminated" |
*
* @param {Welcome_Phase_LostInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_lost = /** @type {((inputs?: Welcome_Phase_LostInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_LostInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_lost(inputs)
	if (locale === "fr") return fr_welcome_phase_lost(inputs)
	return ms_sg2_welcome_phase_lost(inputs)
});